// wishlist-view.js
document.addEventListener('DOMContentLoaded', function() {
  // Check if localStorage is available
  if (typeof Storage !== 'undefined') {
    // Retrieve existing wishlist or create an empty array
    var wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
    
    $('#wishlist_ids').val(wishlist);
    // Display the wishlist items on the page
    var wishlistContainer = document.getElementById('wishlist-container');
    if (wishlistContainer) {
      wishlist.forEach(function(productId) {
        /*var listItem = document.createElement('li');
        listItem.textContent = 'Product ID: ' + productId;
        wishlistContainer.appendChild(listItem);*/

        $.ajax({
            url:  '/products/' + productId +'.json',
           type: 'GET'
           }).done(function(product) {
              displayProductDetails(product, productId);
              //console.log(product);
              /* var productItem = document.createElement('div');
              productItem.className = 'wishlist-product';
  
              var productName = document.createElement('h3');
              productName.textContent = product.title;
  
              var productPrice = document.createElement('p');
              productPrice.textContent = '$' + product.price;
  
              var addToCartButton = document.createElement('button');
              addToCartButton.textContent = 'Add to Cart';
              addToCartButton.addEventListener('click', function() {
                 console.log('Product added to cart:', product.title);
              });
  
              productItem.appendChild(productName);
              productItem.appendChild(productPrice);
              productItem.appendChild(addToCartButton);
  
              wishlistContainer.appendChild(productItem);*/
        });
      });
    }     
  } else {
    console.error('LocalStorage is not supported!');
  }
});

function displayProductDetails(productinfo, productId) {
  const product = productinfo['product'];

  // Create product details container
  var productDetails = document.createElement('div');
  productDetails.classList.add('product-details');
  
  const productDetailsContainerDiv = document.createElement('div');
  productDetailsContainerDiv.classList.add("productDetailsContainer");
  productDetailsContainerDiv.id = 'productDetailsContainer_'+productId;

  const wishlist_container = document.getElementById('wishlist-container');
  wishlist_container.appendChild(productDetailsContainerDiv);
  
  const productDetailsContainer = document.getElementById('productDetailsContainer_'+productId);

  if (productDetailsContainer) {
    //console.log('productId : '+productId);
    
    // Create product image container
    var productImage = document.createElement('div');
    productImage.classList.add('product-image');
    
    // Create image element
    var image = document.createElement('img');
    image.src = product.images[0].src;
    image.alt = product.title;
    
    // Append image to product image container
    productImage.appendChild(image);

    // Create product info container
    var productInfo = document.createElement('div');
    productInfo.classList.add('product-info');
    
    // Create product name heading
    var productName = document.createElement('h2');
    productName.innerText = product.title;

    // Create product price paragraph
    var productPrice = document.createElement('p');
    productPrice.innerText = 'Price: '+product.variants[0].price;

    var viewProductButton = document.createElement('button');
    viewProductButton.textContent = 'View Product';
    viewProductButton.addEventListener('click', function () {
      window.location.href = product.url; // Redirect to the product page
    });

    var removeProductButton = document.createElement('button');
    removeProductButton.textContent = 'Remove Product';
    removeProductButton.classList.add('remove-from-wishlist');
    removeProductButton.setAttribute('data-product-id', productId);
    
    // Append elements to product info container
    productInfo.appendChild(productName);
    productInfo.appendChild(productPrice);
    productInfo.appendChild(viewProductButton);
    //productInfo.appendChild(removeProductButton);
    
    // Append product image and product info to product details container
    productDetails.appendChild(productImage);
    productDetails.appendChild(productInfo);


    productDetailsContainer.appendChild(productDetails);
  }
}
